import {useEffect, useState} from "react";
import { Field, useFormState, FormSpy } from "react-final-form";
import { Label } from "../../../shared/components/form/Layout";
import DateInput from "../../../shared/components/form/DateInput";
import InputNumber from "../../../shared/components/form/InputNumber";
import FieldContainer from "../../../shared/containers/form/FieldContainer";
import ErrorContainer from "../../../shared/containers/form/ErrorContainer";
import { useTranslation } from "react-i18next";
import Tooltip from "../../../shared/components/Tooltip";
import StepFinderSelect from "../../../booking/components/form/StepFinderSelect";
import {
    moseOverStop,
    selectDeparture,
    selectArrival,
    selectStep,
    selectStop,
    showStops,
    setDirection
} from "../../../../data/booking/actions/map";
import { useDispatch, useSelector } from "react-redux";
import LodgingSelect from "../../../booking/components/form/LodgingSelect";
import Textarea from "../../../shared/components/form/Textarea";
import Divider from "../../../shared/components/Divider";
import {
    MapPinIcon,
    HomeIcon,
    CalendarIcon,
    BriefcaseIcon,
} from "@heroicons/react/20/solid";
import Checkbox from "../../../shared/components/form/Checkbox";
import SlideInAnimation from "../../../shared/components/SlideInAnimation";
import WithStage from "../../../shared/components/form/WithStage";
import {RadioGroup} from "../../../shared/components/form/RadioGroup";
import {getDirections} from "../../../../data/booking/selectors/hike";
import {startAt} from "../../../../data/booking/selectors/bag_transport_form";
import {isEmpty} from "lodash";
import { getPreviousEditingItem, getNextEditingItem, getEditingItem } from '../../../../data/booking/selectors/booking';
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import moment from "moment"

let updateReduxField = (field) => {
    if (!window.rduxFm) {
        window.rduxFm = {};
    }
    window.rduxFm.currentField = field;
}

const StepFormFields = ({ form, mutators }) => {
    const { t } = useTranslation();
    const {trip, direction} = useSelector((state) => state.booking.map);
    const previousItem = useSelector((state) => getPreviousEditingItem(state.booking));
    const currentItem = useSelector((state) => getEditingItem(state.booking));
    const nextItem = useSelector((state) => getNextEditingItem(state.booking));
    const [askForPreviousUpdate, setAskForPreviousUpdate] = useState(false)
    const [askForNextUpdate, setAskForNextUpdate] = useState(false)
    const isEditing = useSelector((state) => state.booking.booking.editingService);
    const startAtDate = useSelector(state => startAt(state.booking))
    const departure = trip.startStep;
    const arrival = trip.endStep;
    const dispatch = useDispatch();
    const { values } = useFormState();
    const departureLodgingNotFound = values["departureLodgingNotFound"];
    const arrivalLodgingNotFound = values["arrivalLodgingNotFound"];
    const directions = useSelector((state) => getDirections(state))

    useEffect(() => {
        updateReduxField(null)
        window.rduxFm = {
            ...window.rduxFm,
            setFormValue: mutators.setValue,
        };
    }, []);

    return (
        <WithStage form={form} isEditing={isEditing}>
            {({updateStage, getFieldStage, resetStage, stage })=> {
                return <>
                    <FormSpy
                        subscription={{ values: true }}
                        onChange={(values) => updateStage(values.values)}
                    />
                    <Divider className={"my-8"}>Bagages et date</Divider>
                    <section className="px-4 sm:flex sm:gap-16 sm:px-16">
                        <div className="sm:w-1/2">
                            <FieldContainer name="bags">
                                <Label htmlFor="bags" Icon={BriefcaseIcon}>
                                    {t("booking.bag_transport_bags")}
                                    <Tooltip content="13kg max/bagage" className={"ml-2"} />
                                </Label>
                                <Field
                                    id="bags"
                                    name="bags"
                                    placeholder="0"
                                    component={InputNumber}
                                />
                                <ErrorContainer name="bags" />
                            </FieldContainer>
                        </div>
                        <div className="mt-8 sm:mt-0 sm:w-1/2">
                            <FieldContainer name="date">
                                <Label Icon={CalendarIcon} htmlFor="date">
                                    {t("booking.departure_date")}
                                </Label>
                                <Field
                                    id="date"
                                    name="date"
                                    placeholder="jj/mm/aaaa"
                                    component={DateInput}
                                    disabledAfter={startAtDate}
                                />
                                <ErrorContainer name="date" />
                            </FieldContainer>
                        </div>
                    </section>

                    {trip.hike.pathDetails.bothWays && <SlideInAnimation show={stage >= getFieldStage("date")}>
                        <Divider className={"my-8"}>Sens de la marche</Divider>
                        <section className="px-4 sm:flex sm:gap-16 sm:px-16">
                            <div className="sm:w-full flex justify-center">

                                <FieldContainer name="direction">
                                    <Label htmlFor="direction">
                                        Vous marcherez en direction de :
                                    </Label>
                                    <Field
                                        onChange={(value)=> {
                                            dispatch(setDirection(value.value))
                                            dispatch(selectDeparture(null));
                                            dispatch(selectArrival(null));
                                            mutators.setValue("from", null);
                                            mutators.setValue("to", null);
                                            mutators.setValue("fromStep", null);
                                            mutators.setValue("toStep", null);
                                        }}
                                        id="direction"
                                        name="direction"
                                        options={directions}
                                        component={RadioGroup}
                                    />
                                    <ErrorContainer name="direction" />
                                </FieldContainer>
                            </div>
                        </section>
                    </SlideInAnimation>}

                    <SlideInAnimation show={stage >= getFieldStage(trip.hike.pathDetails.bothWays ? "direction" : "date")}>
                        <Divider>Départ</Divider>
                        <div className={"space-y-8 px-4 lg:px-16"}>
                            <FieldContainer name="fromStep">
                                <Label htmlFor="fromStep" Icon={MapPinIcon}>
                                    {t("booking.departure_from")}
                                </Label>
                                <Field
                                    hikeId={trip.hike.id}
                                    //value={departure.step}
                                    showDistance={false}
                                    onChange={(step) => {
                                        updateReduxField("from")
                                        mutators.setStop(null, "from");
                                        mutators.setValue("departureLodgingNotFound", false);
                                        dispatch(selectDeparture(step));
                                        dispatch(showStops());
                                        if(stage > getFieldStage('fromStep')) {
                                            resetStage("fromStep")
                                        }
                                    }}
                                    placeholder="Étape de départ"
                                    getOptionLabel={(option) => option.title}
                                    ariaLiveMessages={{
                                        onFocus: ({ focused }) => {
                                            dispatch(moseOverStop(focused.id));
                                        },
                                    }}
                                    id="fromStep"
                                    name="fromStep"
                                    direction={direction}
                                    isClearable={true}
                                    component={StepFinderSelect}
                                />

                                <ErrorContainer name="fromStep" />
                            </FieldContainer>

                            <SlideInAnimation show={stage >= getFieldStage("fromStep")}>
                                <FieldContainer name="from">
                                    <Label htmlFor="from" Icon={HomeIcon}>
                                        {t("shared.specify_lodging")} :{" "}
                                    </Label>
                                    <div>
                                        <Field
                                            key={departure.step && departure.step.id + departure.stop?.id}
                                            classNamePrefix="select"
                                            step={departure.step ? departure.step.id : null}
                                            route={departure.step ? null : trip.hike.routeId}
                                            onFocus={() => {
                                                updateReduxField("from")
                                                dispatch(showStops());
                                                if (departure.step) {
                                                    dispatch(selectStep(departure.step));
                                                }
                                            }}
                                            onChange={(stop) => {
                                                if (stop) {
                                                    mutators.setValue("departureLodgingNotFound", false);
                                                    mutators.setStep(stop, "from");
                                                    dispatch(selectDeparture(stop.step, stop.stop));
                                                    dispatch(selectStop(stop.step, stop.stop));
                                                } else {
                                                    dispatch(selectStop(null, null));
                                                    dispatch(selectDeparture(departure.step));
                                                    dispatch(showStops());
                                                }
                                                setAskForPreviousUpdate(true)
                                            }}
                                            placeholder="Hébergement"
                                            name="from"
                                            component={LodgingSelect}
                                        />

                                        <ErrorContainer name="from" />
                                    </div>
                                </FieldContainer>

                                {isEmpty(departure.stop) && <div className={"mt-4 space-y-2"}>
                                    <Field
                                        name="departureLodgingNotFound"
                                        label="Je n'ai pas trouvé mon hébergement :"
                                        type="checkbox"
                                        comment={<span>Si votre hébergement n’apparaît pas dans la liste, cliquez sur la case à cocher. Indiquez-nous ensuite en commentaire l’établissement souhaité <span className="font-bold">et son adresse mail de contact.</span></span>}
                                        component={Checkbox}
                                        onChange={value => {
                                            setAskForPreviousUpdate(true)
                                            updateReduxField("from")
                                            mutators.setStop(null, "from");
                                            dispatch(selectDeparture(departure.step));
                                        }}
                                    />

                                    <Field
                                        id="departureLodgingInformation"
                                        name="departureLodgingInformation"
                                        component={Textarea}
                                        rows="4"
                                        placeholder="Nom de l'hébergement, adresse, contact..."
                                        className={departureLodgingNotFound ? "block" : "hidden"}
                                    />
                                </div>}

                                {previousItem && askForPreviousUpdate && <div className="mt-4">
                                    <Field
                                        name="updatePreviousItem"
                                        defaultValue={previousItem.to && currentItem.from && previousItem.to.id == currentItem.from.id}
                                        label={<span className="flex items-center"><ExclamationTriangleIcon className="text-orange-500 h-4 w-4 mr-1"/> Modifier aussi l'hébergement d'arrivée de l'étape précédente ({moment(previousItem.date).format('DD/MM')})</span>}
                                        type="checkbox"
                                        component={Checkbox}
                                    />
                                </div>}
                            </SlideInAnimation>
                        </div>
                    </SlideInAnimation>

                    <SlideInAnimation show={stage >= getFieldStage("from") || stage >= getFieldStage("departureLodgingNotFound")}>
                        <Divider>Arrivée</Divider>
                        <div className={"space-y-8 px-4 sm:px-16"}>
                            <FieldContainer name="toStep" className="col-md-12 col-xxl-6">
                                <Label htmlFor="to" Icon={MapPinIcon}>
                                    {t("booking.departure_to")}
                                </Label>
                                <Field
                                    key={departure?.step?.id}
                                    hikeId={trip?.hike?.id}
                                    //value={arrival.step}
                                    showDistance={!trip.hike.pathDetails.multiPath}
                                    fromStepId={departure?.step?.id}
                                    onChange={(step) => {
                                        setAskForNextUpdate(true)
                                        updateReduxField("to")
                                        mutators.setStop(null, "to");
                                        dispatch(selectArrival(step));
                                        dispatch(showStops());
                                    }}
                                    placeholder="Étape d'arrivée"
                                    name="toStep"
                                    direction={direction}
                                    component={StepFinderSelect}
                                    isClearable={true}
                                />

                                <ErrorContainer name="toStep" />
                            </FieldContainer>

                            <SlideInAnimation show={stage >= getFieldStage("toStep")}>
                                <FieldContainer name="to" className="col-md-12 col-xxl-6">
                                    <Label className="col-xs-2" htmlFor="to" Icon={HomeIcon}>
                                        {t("shared.specify_lodging")}
                                    </Label>

                                    <div>
                                        <Field
                                            key={arrival?.step && arrival?.step.id + arrival.stop?.id}
                                            classNamePrefix="select"
                                            step={arrival.step ? arrival.step.id : null}
                                            route={arrival.step ? null : trip.hike.routeId}
                                            onFocus={() => {
                                                dispatch(showStops());
                                                if (arrival.step) {
                                                    updateReduxField("to")
                                                    dispatch(selectStep(arrival.step));
                                                }
                                            }}
                                            onChange={(stop) => {
                                                if (stop) {
                                                    mutators.setStep(stop, "to");
                                                    mutators.setValue("arrivalLodgingNotFound", false);
                                                    dispatch(selectArrival(stop.step, stop.stop));
                                                    dispatch(selectStop(stop.step, stop.stop));
                                                } else {
                                                    dispatch(selectStop(null, null));
                                                    dispatch(selectArrival(arrival.step));
                                                    dispatch(showStops());
                                                }
                                                setAskForNextUpdate(true)
                                            }}
                                            placeholder="Hébergement"
                                            name="to"
                                            component={LodgingSelect}
                                        />

                                        <ErrorContainer name="to" />
                                    </div>
                                </FieldContainer>

                                {isEmpty(arrival.stop) && <div className={"mt-4 space-y-4"}>
                                    <Field
                                        key={"arrivalLodgingNotFound" + arrival.step?.id}
                                        name="arrivalLodgingNotFound"
                                        label="Je n'ai pas trouvé mon hébergement :"
                                        comment={<span>Si votre hébergement n’apparaît pas dans la liste, cliquez sur la case à cocher. Indiquez-nous ensuite en commentaire l’établissement souhaité <span className="font-bold">et son adresse mail de contact.</span></span>}
                                        component={Checkbox}
                                        type="checkbox"
                                        onChange={value => {
                                            updateReduxField("to")
                                            mutators.setStop(null, "to");
                                            dispatch(selectArrival(arrival.step));
                                        }}
                                    />

                                    <Field
                                        id="arrivalLodgingInformation"
                                        name="arrivalLodgingInformation"
                                        component={Textarea}
                                        rows="4"
                                        placeholder="Nom de l'hébergement, adresse, contact..."
                                        className={arrivalLodgingNotFound ? "block" : "hidden"}
                                    />
                                </div>}

                                {nextItem && askForNextUpdate && <div className="mt-4">
                                    <Field
                                        name="updateNextItem"
                                        defaultValue={nextItem.from && currentItem.to && currentItem.to.id == nextItem.from.id}
                                        label={<span className="flex items-center"><ExclamationTriangleIcon className="text-orange-500 h-4 w-4 mr-1"/> Modifier aussi l'hébergement de départ de l'étape suivante ({moment(nextItem.date).format('DD/MM')})</span>}
                                        type="checkbox"
                                        component={Checkbox}
                                    />
                                </div>}
                            </SlideInAnimation>
                        </div>
                    </SlideInAnimation>
                </>
            }}
        </WithStage>
    );
};

export default StepFormFields;
